module.exports = __webpack_public_path__ + "static/img/1052.41cc99b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1052.jpg
// module id = 234
// module chunks = 0